var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{staticClass:"select-field mr-2",staticStyle:{"height":"36px"},attrs:{"items":_vm.searchItems,"item-value":"id","item-text":"name","placeholder":_vm.placeholder,"clearable":"","outlined":"","dense":""},on:{"change":_vm.onChangeHandler},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})
}
var staticRenderFns = []

export { render, staticRenderFns }